interface PackagingTotalWeightBadgeProps {
  label: string;
  value: number | string;
  unit?: string;
}

/** Format weight preserving sub-0.1 kg packaging mass (e.g. 0.5 g → 0.0005 kg). */
export const formatWeightNumber = (value: number): string => {
  const abs = Math.abs(value);
  const hasSubTenthPrecision =
    Number.isFinite(value) && Math.abs(abs * 10 - Math.round(abs * 10)) > 1e-9;

  if (hasSubTenthPrecision) {
    return parseFloat(value.toFixed(4)).toString();
  }

  return value.toFixed(1);
};

const formatWeightValue = (value: number | string, unit?: string) => {
  if (value === null || value === undefined || value === "" || value === 0) {
    return "—";
  }

  const numericValue = typeof value === "number" ? value : Number(value);
  const formatted = Number.isFinite(numericValue)
    ? formatWeightNumber(numericValue)
    : String(value);

  return unit ? `${formatted} ${unit}` : formatted;
};

const PackagingTotalWeightBadge = ({ label, value, unit }: PackagingTotalWeightBadgeProps) => {
  return (
    <div className="tw-shrink-0 tw-flex tw-items-center tw-gap-2 tw-bg-muted/30 tw-rounded-lg tw-px-4 tw-py-2.5 tw-border tw-border-border">
      <span className="tw-text-xs tw-font-medium tw-text-foreground tw-whitespace-nowrap">
        {label}
      </span>
      <span className="tw-text-sm tw-font-mono tw-font-semibold tw-text-primary">
        {formatWeightValue(value, unit)}
      </span>
    </div>
  );
};

export default PackagingTotalWeightBadge;
